export * from './Component';
export type { CommonButtonProps } from './typing';
